//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'formatedTextInput',
    props: ["value", "rules"],
    data() {
        return {
            isInputActive: false,
        };
    },
    computed: {
        displayValue: {
            get: function() {
                return this.value.toString().replace('.', ',');
            },
            set: function(modifiedValue) {
                let newValue = parseFloat(modifiedValue.replace(',', '.'));
                if (isNaN(newValue)) {
                    newValue = 0;
                }
                this.$emit('input', newValue);
            },
        },
    },
};
